import { render, staticRenderFns } from "./direct_charge.vue?vue&type=template&id=2d8af652&scoped=true&"
import script from "./direct_charge.vue?vue&type=script&lang=js&"
export * from "./direct_charge.vue?vue&type=script&lang=js&"
import style0 from "./direct_charge.vue?vue&type=style&index=0&id=2d8af652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8af652",
  null
  
)

export default component.exports